import { httpClient } from '../api/http.client';
import {
  Product,
  ProductsResponse,
  ProductResponse,
  CreateProductDto,
  UpdateProductDto,
} from '@/domain/entities';

export interface ProductFilters {
  limit?: number;
  offset?: number;
  search?: string;
  category?: string;
  categoryId?: number;
  subcategory?: string;
  subcategoryId?: number;
  brand?: string;
}

export class ProductRepository {
  async getAll(filters: ProductFilters = {}): Promise<ProductsResponse> {
    const params = new URLSearchParams();
    
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.offset) params.append('offset', filters.offset.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.category) params.append('category', filters.category);
    if (filters.categoryId) params.append('categoryId', filters.categoryId.toString());
    if (filters.subcategory) params.append('subcategory', filters.subcategory);
    if (filters.subcategoryId) params.append('subcategoryId', filters.subcategoryId.toString());
    if (filters.brand) params.append('brand', filters.brand);

    const queryString = params.toString();
    return httpClient.get<ProductsResponse>(
      `/api/admin/products${queryString ? `?${queryString}` : ''}`
    );
  }

  async getBySku(sku: string): Promise<ProductResponse> {
    return httpClient.get<ProductResponse>(`/api/admin/products/${sku}`);
  }

  async create(product: CreateProductDto): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/products', product);
  }

  async update(sku: string, updates: UpdateProductDto): Promise<{ message: string }> {
    return httpClient.put<{ message: string }>(`/api/admin/products/${sku}`, updates);
  }

  async delete(sku: string): Promise<void> {
    return httpClient.delete<void>(`/api/admin/products/${sku}`);
  }

  async fetchBySku(sku: string): Promise<{
    data: {
      image_url: string;
      images: string[];
      sku: string;
      brand: string;
      model?: string;
      name: string;
      color: string;
      main_color?: string;
    };
  }> {
    return httpClient.get<{
      data: {
        image_url: string;
        images: string[];
        sku: string;
        brand: string;
        model?: string;
        name: string;
        color: string;
        main_color?: string;
      };
    }>(`/api/admin/products/fetch-by-sku/${sku}`);
  }

  async getBrands(): Promise<import('@/domain/entities').BrandsResponse> {
    return httpClient.get<import('@/domain/entities').BrandsResponse>('/api/admin/products/utils/brands');
  }

  async getNextId(): Promise<import('@/domain/entities').NextIdResponse> {
    return httpClient.get<import('@/domain/entities').NextIdResponse>('/api/admin/products/utils/next-id');
  }

  async checkExists(sku: string): Promise<{ exists: boolean }> {
    return httpClient.get<{ exists: boolean }>(`/api/admin/products/check/${sku}`);
  }
}

export const productRepository = new ProductRepository();

